
import {Component, Vue} from "vue-property-decorator";
import {getPageAPIs, Util} from "@/common/util";
import {excuteDownloadExport2Excel} from "@/common/xlsx";
import CoachListAPIClass from "@/common/api/coachList";
import { CommonApi } from "@/common/api/common";
import {default_fee_type_arr,default_fee_type_obj} from '@/config/index';
export const pageApiList = getPageAPIs(CoachListAPIClass);

const defaultAddForms = {
  name:'',
  phone:'',
  price:'',
  number:'',
  level:1,
  avatar:'',
  fee_type:1
};
function createPicItem(id: number, url: string) {
  const item = {
    id,
    url,
    href: url,
    type: "image/png",
    types: "1",
  };

  return item;
}
@Component({})
export default class UserList extends Vue {
  private CoachListAPI: any = new CoachListAPIClass();
  private commonApi: any = new CommonApi();
  private forms: any = {

  };
  private form: any = {
    time: [], // 时间选择
  };
  private levelArray:any[] = [
    {label:'实习助教',value:4},
    {label:'初级助教',value:1},
    {label:'中级助教',value:2},
    {label:'高级助教',value:3},
    {label:'星级助教',value:5},
    {label:'明星助教',value:6 }
  ]
  private rules:any =  {
    name: [
      { required: false, message: '赠送金额必填', trigger: 'blur' },
    ],
    phone: [
      { required: false, message: '请输入手机号', trigger: 'blur' },
    ],
    number: [
      { required: true, message: '编号必填', trigger: 'blur' },
    ],
  }
  private fee_type_arr:any[] = [...default_fee_type_arr]
  private fee_type_obj:any = {...default_fee_type_obj}
  private activated(): void {
    this.getTable();
  }

  private getTable(): void {
    this.CoachListAPI.assistantlist(
        {
          ...this.form,
          page: this.tablePage.pageNo,
          limit: this.tablePage.pageSize,
        },
        (res: any) => {
          this.tableData = res.data.list;
          this.tablePage.totalCount = res.data.count;
          this.tablePage.pageNo = res.data.page;
          this.tablePage.pageSize = res.data.prepage;
        }
    );
  }

  private coachshow: boolean = false;
  private title: string = "";

  private addcoach(row: any) {
    this.forms = {...defaultAddForms};
    if (row == 1) {
      this.title = `新增`;
    } else {
      this.title = `编辑`;
      this.forms = row;
      this.avatar_images = row.avatar ? [createPicItem(row.avatar, row.avatar_url)] : [];
    }
    this.coachshow = true;
  }
  private onInputPrice(value:string){
    this.forms.number = this.forms.number.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/, '$1')
  }
  private submit(): void {
    const params = {...this.forms}
    const avatar_images = this.avatar_images
    if(avatar_images.length){
      params.avatar = avatar_images[0].id
    }else{
      params.avatar = ''
    }
    console.log('提交参数',params)
    if (this.title == `新增`) {
      this.CoachListAPI.assistantadd(params, () => {
        this.coachshow = false;
        Util.showToast("新增成功");
        this.search();
      });
    } else {
      this.CoachListAPI.assistantedit(params, () => {
        this.coachshow = false;
        Util.showToast("修改成功");
        this.search();
      });
    }
  }

  private coachdelete(id: string): void {
    this.CoachListAPI.assistantdelete(
        {
          id: id,
        },
        (res: any) => {
          Util.showToast("删除成功");
          this.search();
        }
    );
  }

  /** 导出excel */
  private downloadExcelLoading: boolean = false;

  // channel渠道字段名 文案对应关系
  private merchantExcelList2ch: any = {
    id: "助教id",
    name: "助教名称",
    phone: "手机",
    price: "计费标准",
    order_time: "接单时长",
    total_price: "累计收益",
    operation_name: "操作人",
    operation_time: "操作时间",
  };
  // 商户Excel 表头的先后顺序
  private merchantExcelSortList: string[] = [
    "id",
    "name",
    "phone",
    "price",
    "order_time",
    "total_price",
    "operation_name",
    "operation_time",
  ];

  // 获取excelJSON数据
  private getExcelJSONDataByList(list: any[], sortKey: string[], map2ch: any) {
    const newList = list.map((eachItem) => {
      const newItem: any = {};

      for (const key of sortKey) {
        const val = eachItem[key];

        const chKey = map2ch[key];
        if (val) {
          newItem[chKey] = val;
        } else {
          newItem[chKey] = "";
        }
      }

      return newItem;
    });

    return newList;
  }

  private handleChangeUploadPic(file: any, fileList: any[]) {

    this.commonApi.getOss(
        file instanceof File ? file : file.raw,
        (res: any) => {
          const { data } = res;
          const { data: uploadImgObjWrap } = data;
          const { item: uploadImgObj } = uploadImgObjWrap;
          const { id, url } = uploadImgObj;
          this.$delete(this,'avatar_images')
          this.$set(this,'avatar_images',[createPicItem(id, url)])
        },
        () => {
          this.$message.error("图片上传失败");
        }
    );
  }
  private handleBeforePreviewPicture(row: any) {
    const avatar_images = this.avatar_images
    const previewItem: any = {
      images: avatar_images.map((pic: any) => pic.url),
      image_count: avatar_images.length
    }

    this.handlePreviewMedia(previewItem)
  }
  private handleFileRemove(file: any, mode: string) {
    this.$delete(this, 'avatar_images');
    this.$set(this, 'avatar_images', []);
  }
  private avatar_images: any = [];

  private handlePreviewMedia(row: any) {
    const { image_count, images } = row || {};

    const urls: any[] = [];

    if (image_count > 0) {
      urls.push(
          ...images.map((img: string) => {
            return {
              title: "",
              type: "image/jpeg",
              href: img,
              thumbnail: img,
            };
          })
      );
    }


    this.avatar_images = urls;
  }
  // 点击导出excel 表格
  private handleExportExcelChannelList() {
    this.form.is_export = 1;
    const form = this.form;
    const {time} = form;

    const params: any = {};

    if (Array.isArray(time) && time.length === 2) {
      params.startDate = Util.dateTimeUtilnohms(this.form.time[0]);
      params.endDate = Util.dateTimeUtilnohms(this.form.time[1]);
    } else {
      this.$message.error("请选择时段");

      return;
    }

    if (params === null) {
      return false;
    }

    this.downloadExcelLoading = true;
    this.CoachListAPI.assistantlist(
        {...this.form, is_export: 1},
        (res: any) => {
          const start_date: string = Util.dateUtil(this.form.time[0]);
          const end_date: string = Util.dateUtil(this.form.time[1]);
          const filename = `助教列表 ${start_date}到${end_date}.xlsx`;
          // const { list: originList } = res.data || {};
          const originList = res.data.list || [];

          // const {
          //   list: originList
          // } = data || {}

          const newList = Array.isArray(originList)
              ? originList.map((item) => {
                // const { orderNum } = item || {};
                const newItem = {
                  ...(item || {}),
                };

                for (let key in item) {
                  if (typeof item[key] == "number") {
                    newItem[key] = item[key].toString();
                  }
                }

                // newItem.orderNum =
                //   typeof orderNum == "number"
                //     ? orderNum.toString()
                //     : orderNum || "";

                return newItem;
              })
              : [];

          if (newList.length > 0) {
            const merchantExcelSortList = this.merchantExcelSortList;

            const merchantExcelList2ch = this.merchantExcelList2ch;

            const excelJSONData = this.getExcelJSONDataByList(
                newList,
                merchantExcelSortList,
                merchantExcelList2ch
            );

            excuteDownloadExport2Excel(excelJSONData, filename);
          } else {
            this.$message.info("选中时段没有可导出的信息");
          }

          // const testData = [
          //   { 主页: "test1223424", 名称: "6800", 数量: "6800", 昵称: "广告主网" },
          //   { 主页: "433", 名称: "6800", 数量: "6800", 昵称: "广告主网" },
          //   { 名称: "22", 商家: "6800", 数量: "6800", 昵称: "广告主网", },
          //   { 名称: "43", 商家: "6800", 数量: "6800", 昵称: "广告主网", },
          //   { 店家: "43", 价格: "6800", 数量: "6800", 昵称: "广告主网", }
          // ]

          this.downloadExcelLoading = false;
        },
        () => {
          this.downloadExcelLoading = false;
        }
    );
  }

  /** end 导出excel */
  private restForm(): void {
    this.form = new Util().clearObject(this.form);

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.form.is_export = 0;
    this.getTable();
  }

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }
}
